<template>
  <div class="w1200 data-update-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回首页</span>
    </div>
    <div class="page-title">开奖数据更新</div>
    <div class="tip-line">
      上传你彩票软件导出的开奖数据文件，系统会自动识别格式、解析开奖号并转换为<b>标准格式</b>，直接生成一条「更新记录」，在下方列表点「下载」即可获取。
      计费规则：<b>免费版每月 3 次、单次 ≤{{ priceInfo ? priceInfo.fileFreeBatchMax : 100 }} 期</b>；超出可购买<b>单次转换（{{ fmtPrice(priceInfo && priceInfo.singlePrice, 2) }} 元/次，不限期数）</b>，或开通<b>会员（{{ fmtPrice(priceInfo && priceInfo.monthPrice, 9.9) }} 元/月、{{ fmtPrice(priceInfo && priceInfo.yearPrice, 68) }} 元/年，不限次）</b>。
    </div>

    <!-- 订阅状态 / 购买记录 -->
    <el-card class="block" shadow="never">
      <div slot="header" class="card-head">
        <span>我的订阅与购买记录</span>
        <div>
          <el-button size="mini" icon="el-icon-refresh" @click="activeTab === 'orders' ? loadOrders() : loadSubscription()">刷新</el-button>
          <el-button type="primary" size="mini" @click="openPay()">开通会员 / 购买次数</el-button>
        </div>
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane name="sub">
          <span slot="label"><i class="el-icon-user"></i> 订阅状态</span>
          <div v-loading="subLoading" class="sub-box">
            <template v-if="subInfo && subInfo.standard">
              <el-tag type="success">会员版</el-tag>
              <span class="sub-item">有效期至：{{ fmtDate(subInfo.endTime) }}（有效期仅包月/包年有）</span>
              <span class="sub-item">数据转换：不限次</span>
            </template>
            <template v-else>
              <el-tag>免费版</el-tag>
              <span class="sub-item">本月转换：{{ subInfo && subInfo.fileMonthUsed !== undefined ? subInfo.fileMonthUsed : (subInfo ? subInfo.monthUsed : 0) }} / {{ subInfo && subInfo.fileMonthLimit !== undefined ? subInfo.fileMonthLimit : (subInfo ? subInfo.monthLimit : 3) }} 次</span>
              <span class="sub-item">本月剩余：{{ subInfo && subInfo.fileRemaining !== undefined ? subInfo.fileRemaining : (subInfo ? subInfo.remaining : 3) }} 次</span>
            </template>
            <span class="sub-item">单次转换余量：<b>{{ subInfo ? (subInfo.singleCreditRemain || 0) : 0 }}</b> 次（¥{{ fmtPrice(priceInfo && priceInfo.singlePrice, 2) }}/次购买即+1，可累计、不清零、无有效期，与会员互不冲突）</span>
          </div>
        </el-tab-pane>
        <el-tab-pane name="orders">
          <span slot="label"><i class="el-icon-tickets"></i> 购买记录</span>
          <el-table v-loading="orderLoading" :data="myOrders" border empty-text="暂无购买记录"
        :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="title" label="购买内容" min-width="200" show-overflow-tooltip />
        <el-table-column label="有效期" min-width="170" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.validDesc || '—' }}</template>
        </el-table-column>
        <el-table-column label="金额" width="100">
          <template slot-scope="{ row }">￥{{ row.money }}</template>
        </el-table-column>
        <el-table-column label="支付方式" width="100">
          <template slot-scope="{ row }">{{ payTypeText(row.payType) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="orderStatusType(row.status)" size="small">{{ orderStatusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订单号" prop="orderNo" width="200" show-overflow-tooltip />
        <el-table-column label="下单时间" width="160">
          <template slot-scope="{ row }">{{ fmtTime(row.createTime) }}</template>
        </el-table-column>
      </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 我的软件数据文件 -->
    <el-card class="block" shadow="never">
      <div slot="header" class="card-head"><span>我的软件数据文件（上传后可一键追加更新）</span></div>
      <div class="upload-box">
        <div class="upload-tip">
          把你软件（大赢家/幸运500/定制软件等）导出的开奖数据文件上传到这里，系统会自动识别格式、解析开奖号，
          并直接生成一条「更新记录」（官方数据为主、补齐你录入的期号）。如需在官方新开奖后刷新，可点击「重新生成」再建一条记录。
          下载的 txt 与你上传时的格式完全一致（号码间隔、期号样式都保持原样），导入软件即完成更新。
        </div>
        <el-form inline class="upload-form">
          <el-form-item label="彩种">
            <el-select v-model="uploadForm.preType" placeholder="请选择彩种" style="width:160px">
              <el-option v-for="p in products" :key="p.preType" :label="p.name" :value="String(p.preType)" />
            </el-select>
          </el-form-item>
          <el-form-item label="格式">
            <el-select v-model="uploadForm.format" placeholder="自动识别" style="width:240px" clearable>
              <el-option v-for="(desc, code) in FORMAT_DESC" :key="code" :label="desc" :value="code" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <input ref="fileInput" type="file" accept=".txt,.csv,.dat" style="display:none" @change="onFilePicked" />
            <el-button @click="$refs.fileInput.click()">选择文件（txt/csv/dat，≤2MB）</el-button>
            <span v-if="uploadForm.fileName" class="picked-name">{{ uploadForm.fileName }}</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="uploadLoading" @click="doUpload">上传</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table v-loading="fileLoading" :data="myFiles" border empty-text="暂无上传文件" row-key="id"
        :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }"
        @expand-change="onExpandChange">
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <div class="file-detail" v-loading="row._loading">
              <template v-if="row._detail">
                <div class="detail-head">
                  <span>解析明细（共 {{ row._detail.hasPeriodRows ? row._detail.rows.length : row._detail.rawLines.length }} 条）</span>
                  <el-tag size="mini" :type="row._detail.hasPeriodRows ? 'success' : 'info'">
                    {{ row._detail.hasPeriodRows ? '已识别期号' : '无期号格式' }}
                  </el-tag>
                </div>
                <template v-if="row._detail.hasPeriodRows">
                  <el-table :data="row._detail.rows" size="mini" border max-height="320"
                    :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                    <el-table-column type="index" label="序号" width="55" />
                    <el-table-column prop="period" label="期号" width="100" />
                    <el-table-column prop="openNbr" label="开奖号" min-width="220">
                      <template slot-scope="s">
                        <span v-if="s.row.openNbr" class="ball-list">
                          <span v-for="(b, bi) in ballList(s.row.openNbr, row.preType)" :key="bi"
                            class="ball" :class="{ 'ball-blue': b.blue, 'ball-plain': b.plain }">{{ b.n }}</span>
                        </span>
                        <span v-else>—</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="saleMoney" label="销售额(元)" width="120">
                      <template slot-scope="s">{{ s.row.saleMoney || '—' }}</template>
                    </el-table-column>
                  </el-table>
                </template>
                <template v-else>
                  <pre class="raw-preview">{{ row._detail.rawLines.join('\n') }}</pre>
                </template>
              </template>
              <div v-else class="detail-empty">展开后自动加载解析明细</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="fileName" label="文件名" show-overflow-tooltip />
        <el-table-column prop="preName" label="彩种" width="100" />
        <el-table-column prop="formatDesc" label="识别格式" show-overflow-tooltip />
        <el-table-column prop="lineCount" label="数据行数" width="90" />
        <el-table-column prop="lastPeriod" label="最新期" width="100">
          <template slot-scope="{ row }">{{ row.lastPeriod || '按行数定位' }}</template>
        </el-table-column>
        <el-table-column label="上传时间" width="160">
          <template slot-scope="{ row }">{{ fmtTime(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" :loading="fileGenLoadingId === row.id" @click="generateFromFile(row)">重新生成</el-button>
            <el-button type="danger" size="mini" @click="removeFile(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 我的更新日志 -->
    <el-card class="block" shadow="never">
      <div slot="header" class="card-head"><span>更新记录（生成后在此下载处理好的 txt）</span></div>
      <el-table v-loading="logLoading" :data="logList" border empty-text="暂无更新记录"
        :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column label="彩种" width="100">
          <template slot-scope="{ row }">{{ lotteryTypeName(row.preType) }}</template>
        </el-table-column>
        <el-table-column prop="formatDesc" label="格式" show-overflow-tooltip />
        <el-table-column label="分区/版本" width="140">
          <template slot-scope="{ row }">{{ zonePhaseText(row) }}</template>
        </el-table-column>
        <el-table-column prop="periodFrom" label="起始期" width="100" />
        <el-table-column prop="periodTo" label="结束期" width="100" />
        <el-table-column prop="recordCount" label="期数" width="80" />
        <el-table-column label="结果" width="90">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
              {{ row.status === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="160">
          <template slot-scope="{ row }">{{ fmtTime(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="success" size="mini" :disabled="row.status !== 1"
              :loading="logDownloadingId === row.id" @click="downloadLog(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="logTotal > 0"
        class="log-page"
        background
        layout="prev, pager, next"
        :total="logTotal"
        :page-size="logQuery.pageSize"
        :current-page.sync="logQuery.pageNum"
        @current-change="loadLogs"
      />
    </el-card>

    <!-- 购买弹窗：会员（月/年）或单次转换 -->
    <el-dialog :title="order ? '订单支付' : '选择套餐'" :visible.sync="payDialog" width="460px" append-to-body @closed="onPayClosed">
      <div v-if="order" class="pay-box">
        <div class="pay-summary">
          <div class="summary-row">
            <span class="label">订单号</span>
            <span class="value order-no">{{ order.orderNo }}</span>
          </div>
          <div class="summary-row">
            <span class="label">支付方式</span>
            <span class="value">{{ payTypeText(order.payType) }}</span>
          </div>
          <div class="summary-row">
            <span class="label">应付金额</span>
            <span class="value amount"><i class="amount-symbol">¥</i>{{ order.money }}</span>
          </div>
        </div>

        <div v-if="order.payType === 'wxpay'" class="qr-wrap">
          <div class="qr-frame">
            <div ref="qrBox" class="qr-img"></div>
            <span class="qr-corner tl"></span>
            <span class="qr-corner tr"></span>
            <span class="qr-corner bl"></span>
            <span class="qr-corner br"></span>
          </div>
          <div class="qr-tip"><span class="wx-dot"></span>请使用<b>微信扫一扫</b>完成支付</div>
          <div class="qr-sub">支付成功后状态会自动刷新，也可点击下方「我已支付，刷新状态」</div>
        </div>

        <div v-else-if="order.payType === 'alipay'" class="qr-wrap">
          <div class="qr-frame">
            <div ref="aliQrBox" class="qr-img"></div>
            <span class="qr-corner tl"></span>
            <span class="qr-corner tr"></span>
            <span class="qr-corner bl"></span>
            <span class="qr-corner br"></span>
          </div>
          <div class="qr-tip"><span class="ali-dot"></span>请使用<b class="ali">支付宝扫一扫</b>完成支付</div>
          <div class="qr-sub">支付成功后状态会自动刷新，也可点击下方「我已支付，刷新状态」</div>
        </div>

        <div v-else class="balance-tip">
          <i class="el-icon-success"></i>
          <span>缩币支付订单已创建并即时完成扣款，如订阅状态未更新，请点击下方「我已支付，刷新状态」。</span>
        </div>
      </div>
      <div v-else class="pay-form">
        <div v-if="paywallMsg" class="paywall-msg">{{ paywallMsg }}</div>
        <div
          v-for="p in planOptions"
          :key="p.key"
          class="plan-item"
          :class="{ active: subscribeForm.buyType === p.key }"
          @click="subscribeForm.buyType = p.key"
        >
          <div>
            <div class="plan-name">
              {{ p.name }}
              <span v-if="p.key === 'year'" class="plan-badge">划算</span>
            </div>
            <div class="plan-tip">{{ p.tip }}</div>
          </div>
          <div class="plan-price">
            <span class="price-num">¥{{ p.price }}</span>
            <span class="price-unit">/{{ p.unit }}</span>
            <span v-if="subscribeForm.buyType === p.key" class="plan-check">✓</span>
          </div>
        </div>
        <div class="pay-type-row">
          <span class="pay-type-label">支付方式</span>
          <el-radio-group v-model="subscribeForm.payType">
            <el-radio label="balancepay">缩币</el-radio>
            <el-radio label="wxpay">微信</el-radio>
            <el-radio label="alipay">支付宝</el-radio>
          </el-radio-group>
        </div>
        <div class="free-rule">免费版：每月 {{ subInfo && subInfo.fileMonthLimit !== undefined ? subInfo.fileMonthLimit : 3 }} 次、单次 ≤{{ priceInfo ? priceInfo.fileFreeBatchMax : 100 }} 期；会员不限次、不限期数</div>
        <div v-if="disclaimerText" class="disclaimer">{{ disclaimerText }}</div>
      </div>
      <div slot="footer">
        <template v-if="order">
          <el-button @click="payDialog = false">关闭</el-button>
          <el-button type="primary" @click="refreshAfterPay">我已支付，刷新状态</el-button>
        </template>
        <template v-else>
          <el-button @click="payDialog = false">取消</el-button>
          <el-button type="primary" :loading="payLoading" @click="doSubscribe">立即支付</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProducts, getSubscription, getLogList, subscribe, buySingle, getPrice, uploadMyFile, getMyFiles, deleteMyFile, getMyFileDetail, generateData, downloadLog, checkOrder, getMyOrders } from "@/api/dataUpdate";
import QRCode from 'qrcodejs2';

// 后端 generate 接口的请求体字段
// { preType, format, zone, phase, periodFrom, periodTo, fileId }

// 付费墙业务码：后端超免费额度/超单次期数时抛 ServiceException(code=4801)
const PAYWALL_CODE = 4801;

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

// 后端 formatCodes 返回的是字符串数组（DataUpdateFormatEnum.code），描述在前端维护
const FORMAT_DESC_MAP = {
  DYJ_1: '期号 红球+蓝球（大赢家格式1）',
  DYJ_2: '仅开奖号码（大赢家格式2）',
  DYJ_3: '仅红球/仅前区（大赢家格式3）',
  DYJ_4: '期号+开奖号（大赢家格式4）',
  DYJ_5: '期数/日期/开奖号/销售额/一二等 CSV（大赢家格式5）',
  COLON: '期号:前区+后区（定制软件格式）',
  XY500: '幸运500样式（5位期号，竖线分区）',
};

export default {
  name: "DataUpdate",
  data() {
    return {
      products: [],
      subInfo: null,
      subLoading: false,
      logList: [],
      logTotal: 0,
      logLoading: false,
      logDownloadingId: null,
      logQuery: { pageNum: 1, pageSize: 20 },
      myFiles: [],
      fileLoading: false,
      fileGenLoadingId: null,
      myOrders: [],
      orderLoading: false,
      activeTab: 'sub',
      uploadForm: { preType: '', format: '', fileName: '', file: null },
      uploadLoading: false,
      payDialog: false,
      payLoading: false,
      order: null,
      priceInfo: null,
      paywallMsg: '',
      subscribeForm: { buyType: 'month', payType: 'balancepay' },
      payPollTimer: null,
      payPollCount: 0,
    };
  },
  computed: {
    FORMAT_DESC() {
      return FORMAT_DESC_MAP;
    },
    disclaimerText() {
      return (this.priceInfo && this.priceInfo.disclaimer) ||
        '历史开奖数据为公开统计数据，仅用于历史走势查看，不构成购彩建议；本服务为数据格式化技术服务，不提供荐号/预测，不承诺提高中奖概率。';
    },
    planOptions() {
      const p = this.priceInfo || {};
      return [
        { key: 'single', name: '单次转换', tip: '转换一次，不限期数', price: this.fmtPrice(p.singlePrice, 2), unit: '次' },
        { key: 'month', name: '会员月付', tip: '一个月内不限次转换', price: this.fmtPrice(p.monthPrice, 9.9), unit: '月' },
        { key: 'year', name: '会员年付', tip: '一年内不限次转换，长期更划算', price: this.fmtPrice(p.yearPrice, 68), unit: '年' },
      ];
    },
  },
  mounted() {
    this.loadProducts();
    this.loadSubscription();
    this.loadPrice();
    this.loadLogs();
    this.loadMyFiles();
    this.loadOrders();
  },
  beforeDestroy() {
    this.stopPayPolling();
  },
  methods: {
    goBack() {
      this.$router.push('/home');
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[String(type)] || type || '-';
    },
    fmtDate(v) {
      if (!v) return '-';
      try { return new Date(v).toLocaleString('zh-CN'); } catch (e) { return v; }
    },
    // 开奖号按彩种编码渲染：0双色球=6红+1蓝 / 1大乐透=5红+2蓝 / 5七乐彩=7红+1蓝；
    // 2福彩3D / 3排列3 / 6七星彩 / 7排列5 / 8快乐8 官方无红蓝之分，全中性球
    ballList(openNbr, preType) {
      const nums = String(openNbr).trim().split(/\s+/).filter(Boolean);
      const t = Number(preType);
      const blueMap = { 0: 1, 1: 2, 5: 1 };
      const blueCount = blueMap[t] || 0;
      const plain = [2, 3, 6, 7, 8].indexOf(t) > -1;
      return nums.map((n, i) => ({
        n: ('0' + n).slice(-2),
        blue: !plain && blueCount > 0 && i >= nums.length - blueCount,
        plain
      }));
    },
    fmtTime(v) {
      if (!v) return '-';
      const d = new Date(v);
      if (isNaN(d.getTime())) return v;
      const p = n => (n < 10 ? '0' + n : '' + n);
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
    },
    zonePhaseText(row) {
      const z = row.zone === 'FRONT' ? '前区' : (row.zone === 'BACK' ? '后区' : '全部');
      const p = row.phase === 'BEFORE' ? '试前' : '试后';
      return z + ' / ' + p;
    },
    payTypeText(t) {
      return t === 'wxpay' ? '微信' : (t === 'alipay' ? '支付宝' : '缩币');
    },
    orderStatusText(s) {
      const v = String(s);
      return v === '1' ? '已支付' : v === '2' ? '已取消' : v === '3' ? '已关闭' : '待支付';
    },
    orderStatusType(s) {
      const v = String(s);
      return v === '1' ? 'success' : (v === '2' || v === '3') ? 'info' : 'warning';
    },
    loadOrders() {
      this.orderLoading = true;
      getMyOrders().then(res => {
        const data = res && res.data !== undefined ? res.data : res;
        this.myOrders = Array.isArray(data) ? data : [];
      }).catch(() => {}).finally(() => { this.orderLoading = false; });
    },
    fmtPrice(v, fallback) {
      const n = Number(v);
      return isNaN(n) ? fallback : n;
    },
    loadPrice() {
      getPrice().then(res => {
        const data = res && res.data !== undefined ? res.data : res;
        this.priceInfo = data || null;
      }).catch(() => { this.priceInfo = null; });
    },
    loadProducts() {
      getProducts().then(res => {
        const data = res && res.data !== undefined ? res.data : res;
        this.products = Array.isArray(data) ? data : (data && data.rows) || [];
        if (!this.uploadForm.preType && this.products.length) {
          this.uploadForm.preType = String(this.products[0].preType);
        }
      }).catch(() => { this.products = []; });
    },
    loadSubscription() {
      this.subLoading = true;
      getSubscription().then(res => {
        const data = res && res.data !== undefined ? res.data : res;
        this.subInfo = data || null;
      }).catch(() => { this.subInfo = null; })
        .finally(() => { this.subLoading = false; });
    },
    loadLogs(page) {
      if (page) this.logQuery.pageNum = page;
      this.logLoading = true;
      getLogList(this.logQuery).then(res => {
        const data = res && res.data !== undefined ? res.data : res;
        if (Array.isArray(data)) {
          this.logList = data;
          this.logTotal = data.length;
        } else if (data && data.rows) {
          this.logList = data.rows;
          this.logTotal = data.total || data.rows.length;
        } else {
          this.logList = [];
          this.logTotal = 0;
        }
      }).catch(() => { this.logList = []; this.logTotal = 0; })
        .finally(() => { this.logLoading = false; });
    },
    loadMyFiles() {
      this.fileLoading = true;
      getMyFiles().then(res => {
        const data = res && res.data !== undefined ? res.data : res;
        this.myFiles = Array.isArray(data) ? data : (data && data.rows) || [];
      }).catch(() => { this.myFiles = []; })
        .finally(() => { this.fileLoading = false; });
    },
    onExpandChange(row, expandedRows) {
      // 仅在展开且尚未加载时拉取解析明细
      if (expandedRows.indexOf(row) === -1) return;
      if (row._detail || row._loading) return;
      this.$set(row, '_loading', true);
      getMyFileDetail(row.id).then(res => {
        const data = res && res.data !== undefined ? res.data : res;
        // 兜底：接口异常时 data 可能不是预期结构，必须保证 rows/rawLines 是数组
        const d = (data && typeof data === 'object' && Array.isArray(data.rows) && Array.isArray(data.rawLines))
          ? data : { hasPeriodRows: false, rows: [], rawLines: [] };
        this.$set(row, '_detail', d);
      }).catch(() => {
        this.$set(row, '_detail', { hasPeriodRows: false, rows: [], rawLines: [] });
        this.$message.error('加载解析明细失败');
      }).finally(() => { this.$set(row, '_loading', false); });
    },
    onFilePicked(e) {
      const files = e.target.files || [];
      this.uploadForm.file = files[0] || null;
      this.uploadForm.fileName = this.uploadForm.file ? this.uploadForm.file.name : '';
    },
    doUpload() {
      if (!this.uploadForm.preType) {
        this.$message.warning('请先选择彩种');
        return;
      }
      if (!this.uploadForm.file) {
        this.$message.warning('请先选择数据文件');
        return;
      }
      const fd = new FormData();
      fd.append('file', this.uploadForm.file);
      fd.append('preType', this.uploadForm.preType);
      if (this.uploadForm.format) {
        fd.append('format', this.uploadForm.format);
      }
      this.uploadLoading = true;
      uploadMyFile(fd).then(res => {
        if (res && res.code === PAYWALL_CODE) {
          // 付费墙：免费额度用尽/超期数上限，弹出购买引导
          this.$message.warning(res.msg || '免费额度已用完，购买单次转换或开通会员后可继续');
          this.openPay('single', (res && res.msg) || '');
          return;
        }
        this.$message.success('上传成功并已生成更新记录，请在下方「更新记录」中点击「下载」获取处理好的文件');
        this.uploadForm = { preType: this.uploadForm.preType, format: '', fileName: '', file: null };
        if (this.$refs.fileInput) this.$refs.fileInput.value = '';
        this.loadMyFiles();
        this.loadLogs();
        this.loadSubscription();
      }).catch(err => {
        if (err && err.code === PAYWALL_CODE) {
          this.openPay('single', (err && err.msg) || '');
          return;
        }
        this.$message.error('上传失败，请检查文件内容与格式');
      }).finally(() => { this.uploadLoading = false; });
    },
    generateFromFile(row) {
      // 仅"重新生成"一条更新记录（官方新开奖后刷新用），不立即下载
      this.fileGenLoadingId = row.id;
      generateData({ fileId: row.id }).then(res => {
        if (res && res.code === PAYWALL_CODE) {
          this.$message.warning(res.msg || '免费额度已用完，购买单次转换或开通会员后可继续');
          this.openPay('single', (res && res.msg) || '');
          return;
        }
        this.$message.success('已生成更新记录，请在下方「更新记录」中点击「下载」');
        this.loadLogs();
        this.loadSubscription();
      }).catch(err => {
        if (err && err.code === PAYWALL_CODE) {
          this.openPay('single', (err && err.msg) || '');
          return;
        }
        this.$message.error('生成更新记录失败，请稍后重试');
      }).finally(() => { this.fileGenLoadingId = null; });
    },
    downloadLog(row) {
      this.logDownloadingId = row.id;
      downloadLog(row.id).then(res => {
        // 拦截器把 HTTP 错误归一化为普通对象（非 Blob）；后端业务异常也会返回 JSON
        const blob = (res && res.data instanceof Blob) ? res.data : (res instanceof Blob ? res : null);
        if (!blob) {
          const msg = (res && res.msg) || (res && res.data && res.data.msg) || '下载失败';
          this.$message.error(msg);
          return;
        }
        if (blob.type && blob.type.indexOf('application/json') !== -1) {
          return blob.text().then(txt => {
            let msg = '下载失败';
            try { msg = (JSON.parse(txt) || {}).msg || msg; } catch (e) { /* 忽略 */ }
            this.$message.error(msg);
          });
        }
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'data_update_' + row.id + '_'
          + (row.fileName ? row.fileName.replace(/\.[^.]+$/, '') : row.preType) + '.txt';
        a.style.display = 'none';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        this.$message.success('已开始下载处理好的开奖数据文件');
      }).catch(() => {
        this.$message.error('下载失败（可能登录已过期，请刷新后重试）');
      }).finally(() => { this.logDownloadingId = null; });
    },
    removeFile(row) {
      this.$confirm('确定删除「' + row.fileName + '」吗？', '提示', { type: 'warning' }).then(() => {
        deleteMyFile(row.id).then(() => {
          this.$message.success('已删除');
          this.loadMyFiles();
        }).catch(() => { this.$message.error('删除失败'); });
      }).catch(() => {});
    },
    openPay(buyType, paywallMsg) {
      this.order = null;
      this.paywallMsg = paywallMsg || '';
      this.subscribeForm = { buyType: buyType || 'month', payType: 'balancepay' };
      this.payDialog = true;
    },
    doSubscribe() {
      if (!this.subscribeForm.buyType || !this.subscribeForm.payType) {
        this.$message.warning('请选择购买项与支付方式');
        return;
      }
      this.payLoading = true;
      const isSingle = this.subscribeForm.buyType === 'single';
      const req = isSingle
        ? buySingle({ payType: this.subscribeForm.payType })
        : subscribe({ plan: this.subscribeForm.buyType === 'year' ? 'YEAR' : 'MONTH', payType: this.subscribeForm.payType });
      req.then(res => {
        if (res && res.code !== undefined && res.code !== 200) {
          this.$message.error(res.msg || '下单失败，请稍后重试');
          return;
        }
        const data = res && res.data !== undefined ? res.data : res;
        // 缩币支付（balancepay）：后端下单即完成扣款，无需扫码，直接提示成功并刷新状态
        if (this.subscribeForm.payType === 'balancepay') {
          this.payDialog = false;
          this.$message.success('缩币支付成功，已开通');
          this.activeTab = 'orders';
          this.loadSubscription();
          this.loadLogs();
          this.loadMyFiles();
          this.loadOrders();
          return;
        }
        this.order = data || {};
        // 支付宝预下单失败时后端 codeUrl 返回字面量 "error"，此时提示而不是渲染无效二维码
        if (this.order.codeUrl === 'error') {
          this.$message.error('创建支付二维码失败，请稍后重试或改用其他支付方式');
          return;
        }
        // 微信/支付宝：后端均返回 codeUrl（支付链接），用 qrcodejs2 渲染成二维码
        this.$nextTick(() => {
          if (this.order.payType === 'wxpay') {
            this.renderQr();
          } else if (this.order.payType === 'alipay') {
            this.renderAliQr();
          }
        });
        // 微信/支付宝为异步支付：自动轮询订单状态，支付成功后无需手动刷新
        this.startPayPolling();
      }).catch(() => { this.$message.error('下单失败，请稍后重试'); })
        .finally(() => { this.payLoading = false; });
    },
    renderQr() {
      const container = this.$refs.qrBox;
      if (!container || !this.order || !this.order.codeUrl) return;
      // 清空旧二维码再重绘，避免重复叠加
      while (container.firstChild) container.removeChild(container.firstChild);
      new QRCode(container, { text: this.order.codeUrl, width: 200, height: 200 });
    },
    // 支付宝当面付：后端同样返回 codeUrl，渲染为二维码
    renderAliQr() {
      const container = this.$refs.aliQrBox;
      if (!container || !this.order || !this.order.codeUrl) return;
      while (container.firstChild) container.removeChild(container.firstChild);
      new QRCode(container, { text: this.order.codeUrl, width: 200, height: 200 });
    },
    refreshAfterPay() {
      this.loadSubscription();
      this.loadLogs();
      this.loadMyFiles();
      this.loadOrders();
      this.payDialog = false;
      this.$message.success('已刷新订阅状态');
    },
    // 微信/支付宝扫码支付后自动轮询订单状态：每3秒一次，最多约5分钟
    startPayPolling() {
      this.stopPayPolling();
      if (!this.order || !this.order.orderNo) return;
      this.payPollCount = 0;
      this.payPollTimer = setInterval(() => {
        this.payPollCount += 1;
        if (this.payPollCount > 100) {
          this.stopPayPolling();
          return;
        }
        checkOrder(this.order.orderNo).then(res => {
          const status = res && res.data !== undefined ? res.data : res;
          if (String(status) === '1') {
            // 已支付：停止轮询，提示成功并刷新订阅/记录
            this.stopPayPolling();
            this.payDialog = false;
            this.$message.success('支付成功，已开通');
            this.activeTab = 'orders';
            this.loadSubscription();
            this.loadLogs();
            this.loadMyFiles();
            this.loadOrders();
          } else if (String(status) === '2' || String(status) === '3') {
            // 已取消/超时关闭：停止轮询
            this.stopPayPolling();
          }
        }).catch(() => {});
      }, 3000);
    },
    stopPayPolling() {
      if (this.payPollTimer) {
        clearInterval(this.payPollTimer);
        this.payPollTimer = null;
      }
    },
    onPayClosed() {
      this.stopPayPolling();
      this.order = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.data-update-page {
  background: #ffffff;
  padding: 20px;
  margin: 20px auto;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar { margin-bottom: 10px; }
  .back-btn {
    display: inline-block; cursor: pointer; color: #347caf; font-size: 14px;
    padding: 6px 14px; border: 1px solid #347caf; border-radius: 5px;
    &:hover { background-color: #347caf; color: #ffffff; }
  }
  .page-title {
    font-size: 22px; font-weight: bold; color: #347caf; text-align: center;
    padding: 10px 0 20px; border-bottom: 2px solid #347caf; margin-bottom: 20px;
  }
  .tip-line {
    background: #f4f7fb; color: #666; font-size: 13px; padding: 10px 14px;
    border-radius: 6px; margin-bottom: 16px;
  }
  .block { margin-bottom: 18px; }
  .card-head {
    display: flex; align-items: center; justify-content: space-between; font-weight: bold;
  }
  .sub-box { font-size: 14px; }
  .sub-item { margin-left: 16px; color: #555; }
  .tab-badge { margin-left: 4px; }
  .tab-badge ::v-deep .el-badge__content { position: static; transform: none; }
  .log-page { text-align: center; margin-top: 12px; }
  .upload-box { margin-bottom: 14px; }
  .upload-tip {
    background: #f4f7fb; color: #666; font-size: 13px; padding: 10px 14px;
    border-radius: 6px; margin-bottom: 12px; line-height: 1.8;
  }
  .upload-form { margin-bottom: 0; }
  .picked-name { margin-left: 10px; color: #347caf; font-size: 13px; }
  .file-detail { padding: 6px 18px 12px; background: #fafcff; }
  .ball-list { display: inline-flex; align-items: center; gap: 5px; flex-wrap: wrap; }
  .ball {
    display: inline-block; width: 24px; height: 24px; line-height: 24px;
    border-radius: 50%; background: #e8383d; color: #fff;
    font-size: 12px; font-weight: 600; text-align: center;
  }
  .ball-blue { background: #2f7ad9; }
  .ball-plain { background: #4a4a4a; }
  .detail-head { display: flex; align-items: center; margin-bottom: 8px; color: #555; font-size: 13px; }
  .detail-head .el-tag { margin-left: 10px; }
  .raw-preview {
    margin: 0; padding: 10px 12px; background: #fff; border: 1px solid #e8eef5; border-radius: 6px;
    font-size: 12px; line-height: 1.7; color: #333; white-space: pre-wrap; word-break: break-all; max-height: 320px; overflow: auto;
  }
  .detail-empty { color: #999; font-size: 13px; padding: 8px 0; }
}

/* ===================================================================
   订单支付弹窗样式（顶层作用域）
   注意：el-dialog 带 append-to-body，DOM 被移到 body 下，
   不在 .data-update-page 容器内，因此这里必须用顶层选择器，
   否则嵌套在 .data-update-page 里的样式会全部失配。
   =================================================================== */
.pay-box { font-size: 14px; }
.pay-summary {
  background: #f7f8fa; border-radius: 10px; padding: 12px 16px; margin-bottom: 18px;
}
.pay-summary .summary-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 5px 0; font-size: 13px;
}
.pay-summary .summary-row .label { color: #909399; }
.pay-summary .summary-row .value { color: #303133; font-weight: 500; }
.pay-summary .summary-row .order-no { font-family: Consolas, Menlo, monospace; letter-spacing: .5px; }
.pay-summary .summary-row .amount {
  color: #f56c6c; font-size: 22px; font-weight: 700; line-height: 1;
}
.pay-summary .summary-row .amount .amount-symbol {
  font-style: normal; font-size: 13px; font-weight: 600; margin-right: 2px; vertical-align: 2px;
}
.qr-wrap { text-align: center; }
.qr-frame {
  position: relative; display: table; margin: 0 auto; padding: 12px;
  background: #fff; border: 1px solid #ebeef5; border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, .08);
}
.qr-img { width: 200px; height: 200px; background: #fff; }
.qr-img img { display: block; }
.qr-corner {
  position: absolute; width: 14px; height: 14px; border-color: #409eff; border-style: solid; border-width: 0;
}
.qr-corner.tl { top: -1px; left: -1px; border-top-width: 3px; border-left-width: 3px; border-top-left-radius: 12px; }
.qr-corner.tr { top: -1px; right: -1px; border-top-width: 3px; border-right-width: 3px; border-top-right-radius: 12px; }
.qr-corner.bl { bottom: -1px; left: -1px; border-bottom-width: 3px; border-left-width: 3px; border-bottom-left-radius: 12px; }
.qr-corner.br { bottom: -1px; right: -1px; border-bottom-width: 3px; border-right-width: 3px; border-bottom-right-radius: 12px; }
.qr-tip {
  margin-top: 14px; font-size: 14px; color: #303133;
  display: flex; align-items: center; justify-content: center; gap: 6px;
}
.qr-tip b { color: #07c160; }
.wx-dot {
  display: inline-block; width: 8px; height: 8px; border-radius: 50%;
  background: #07c160; box-shadow: 0 0 0 3px rgba(7, 193, 96, .15);
}
.qr-tip b.ali { color: #1677ff; }
.ali-dot {
  display: inline-block; width: 8px; height: 8px; border-radius: 50%;
  background: #1677ff; box-shadow: 0 0 0 3px rgba(22, 119, 255, .15);
}
.qr-sub { margin-top: 6px; font-size: 12px; color: #909399; }
.balance-tip {
  display: flex; align-items: flex-start; gap: 8px;
  background: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 8px;
  padding: 12px 14px; color: #67c23a; font-size: 13px; line-height: 1.7;
}
.balance-tip .el-icon-success { font-size: 18px; margin-top: 1px; }
.balance-tip span { color: #529b2e; }

/* ===== 选择套餐 ===== */
.pay-form { padding: 0 0 4px; }
.paywall-msg {
  color: #f56c6c; font-size: 12px; line-height: 1.7;
  background: #fef0f0; border: 1px solid #fde2e2; border-radius: 8px;
  padding: 10px 12px; margin-bottom: 14px;
}
.plan-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 16px; margin-bottom: 10px; cursor: pointer;
  border: 1px solid #ebeef5; border-radius: 10px; background: #fff;
  transition: all .2s;
}
.plan-item:hover { border-color: #c6e2ff; }
.plan-item.active {
  border-color: #409eff; background: #ecf5ff;
  box-shadow: 0 2px 10px rgba(64, 158, 255, .12);
}
.plan-name { font-size: 14px; color: #303133; font-weight: 600; }
.plan-badge {
  display: inline-block; margin-left: 6px; padding: 1px 7px;
  font-size: 11px; font-weight: 500; color: #fff;
  background: linear-gradient(135deg, #ff9a44, #fc6076); border-radius: 9px; vertical-align: 1px;
}
.plan-tip { font-size: 12px; color: #909399; margin-top: 3px; }
.plan-price { text-align: right; }
.price-num { color: #f56c6c; font-size: 22px; font-weight: 700; }
.price-unit { color: #909399; font-size: 12px; }
.plan-check { color: #409eff; font-size: 13px; font-weight: 700; margin-left: 6px; }
.pay-type-row {
  display: flex; align-items: center; justify-content: center;
  margin-top: 18px; font-size: 13px; color: #606266;
}
.pay-type-label { margin-right: 12px; }
.free-rule { color: #909399; font-size: 12px; line-height: 1.7; margin-top: 12px; text-align: center; }
.disclaimer { color: #c0c4cc; font-size: 11px; line-height: 1.6; text-align: center; margin-top: 8px; }
</style>
